/* eslint-disable */
export default {
  meetingTitle: '{extensionName}님의 모임',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
